/**
 * AI & Intelligence Icons
 *
 * Icons for AI features, automation, and smart suggestions.
 */

import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faBrain as fadBrain,
  faBrainCircuit as fadBrainCircuit,
  faWandMagicSparkles as fadWandMagicSparkles,
  faRobot as fadRobot,
  faLightbulb as fadLightbulb,
  faLightbulbOn as fadLightbulbOn,
  faMagnifyingGlassChart as fadMagnifyingGlassChart,
  faBolt as fadBolt,
  faChartLine as fadChartLine,
  faChartBar as fadChartBar,
  faChartPie as fadChartPie,
  faChartMixed as fadChartMixed,
  faStars as fadStars,
  faPaperPlane as fadPaperPlane,
  faMicrochip as fadMicrochip,
  faFile as fadFile,
  faPills as fadPills,
  faAddressBook as fadAddressBook,
  faFileMedical as fadFileMedical,
  faHospital as fadHospital,
  faStethoscope as fadStethoscope,
  faFileChartColumn as fadFileChartColumn,
  faFilePdf as fadFilePdf,
  faUsers as fadUsers,
  faMessageDots as fadMessageDots,
  faAt as fadAt,
  // ActionsMenuSheet
  faLayerGroup as fadLayerGroup,
  faCalendar as fadCalendar,
  // WelcomeArea
  faFolders as fadFolders,
  faFileLines as fadFileLines,
  faKeyboard as fadKeyboard,
  faCircleCheck as fadCircleCheck,
  faShareNodes as fadShareNodes,
  faSparkles as fadSparkles,
} from '@fortawesome/pro-duotone-svg-icons';

import {
  faSparkles as fasSparkles,
} from '@fortawesome/pro-solid-svg-icons';

export const loadAIIcons = () => {
  library.add(
    fadBrain,
    fadBrainCircuit,
    fadSparkles,
    fadWandMagicSparkles,
    fadRobot,
    fadLightbulb,
    fadLightbulbOn,
    fadMagnifyingGlassChart,
    fadBolt,
    fadChartLine,
    fadChartBar,
    fadChartPie,
    fadChartMixed,
    fadStars,
    fadPaperPlane,
    fadMicrochip,
    fadFile,
    fadPills,
    fadAddressBook,
    fadFileMedical,
    fadHospital,
    fadStethoscope,
    fadFileChartColumn,
    fadFilePdf,
    fadUsers,
    fadMessageDots,
    fadAt,
    fadLayerGroup,
    fadCalendar,
    fadFolders,
    fadFileLines,
    fadKeyboard,
    fadCircleCheck,
    fadShareNodes,
    fasSparkles,
  );
};
